export default {"src":"/_next/static/media/FinancialGroup-1_horizontal.6d194df4.svg","height":210,"width":1066};